document.addEventListener("turbolinks:load", function() {
  $('#search_group').keyup(function() {
    var value = this.value.toLowerCase();
    $(".ui.menu .group").each(function(index) {
      var id = $(this).text().toLowerCase();
      $(this).toggle(id.indexOf(value) !== -1);
    });
  });

  $('a.number.item').on('click', function() {
    var number = $(this).text();
    var text = $('#search_group').val();
    text += number;
    $('#search_group').val(text);
    var value = $('#search_group').val().toLowerCase();
    $(".ui.menu .group").each(function(index) {
      var id = $(this).text().toLowerCase();
      $(this).toggle(id.indexOf(value) !== -1);
    });
  });

  $('.timetable-numbers > a.clear').on('click', function() {
    $('#search_group').val('');
    var value = $('#search_group').val().toLowerCase();
    $(".ui.menu .group").each(function(index) {
      var id = $(this).text().toLowerCase();
      $(this).toggle(id.indexOf(value) !== -1);
    });
  });

  $('.timetable-numbers > a.delete').on('click', function() {
      var converted_text = $('#search_group').val();
      $('#search_group').val(converted_text.slice(0, -1));
      var value = $('#search_group').val().toLowerCase();
      $(".ui.menu .group").each(function(index) {
          var id = $(this).text().toLowerCase();
          $(this).toggle(id.indexOf(value) !== -1);
      });
  });


});
